import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_DOCUMENT_IMPORTER_TEMPLATE_BY_ID } from './get-document-importer-template-by-id.hook';
import { GET_DOCUMENT_IMPORTER_TEMPLATES } from './get-document-importer-templates.hook';



export const DELETE_DOCUMENT_IMPORTER_TEMPLATE_BY_ID = gql`
  mutation deleteDocumentImporterTemplateById($id: String!) {
    deleteDocumentImporterTemplateById(id: $id) {
      _id
    }
  }
`;

export const useDeleteDocumentImporterTemplateById = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const { t } = useTranslation('settings');
  const [deleteDocumentImporterTemplateById] = useMutation(DELETE_DOCUMENT_IMPORTER_TEMPLATE_BY_ID, {
    onCompleted: data => {
      onSuccess();
      if (data?.deleteDocumentImporterTemplateById?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('documentImporter.notifications.deletedSuccessfully'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [
      GET_DOCUMENT_IMPORTER_TEMPLATE_BY_ID,
      GET_DOCUMENT_IMPORTER_TEMPLATES
    ],
  });

  return deleteDocumentImporterTemplateById;
};
